import { Druckvorlage } from '@/models/DruckvorlageModels';

export class Vertragspartner {
  id: number = 0;
  anrede: string = '';
  name: string = '';
  vorname: string = '';
  unternehmen: string = '';
  unternehmenzusatz: string = '';
  strasse: string = '';
  plz: string = '';
  ort: string = '';
  land: string = '';
  notizen: string = '';

  standort: string = '';
  tarifgebiet: string = '';

  kfWaerendProbezeit: string = ''; // Kündigungsfrist während der Probezeit
  kfWaerendProbezeitEN: string = ''; // Kündigungsfrist während der Probezeit
  kfNachProbezeit: string = ''; // Kündigungsfrist nach der Probezeit
  kfNachProbezeitEN: string = ''; // Kündigungsfrist nach der Probezeit

  hrbpStandard: string = '';
  auVorlage: string = '';

  druckvorlagen: VertragspartnerDruckvorlage[] = [];
}

export class VertragspartnerDruckvorlage {
  id: number = 0;
  vertragspartnerId: number = 0;

  druckvorlage: Druckvorlage | null = null;
  druckvorlageId: number = 0;
}

export class Signatur {
  id: number = 0;
  zeichnung: string = '';
  unterschrift: string = '';
  funktion: string = '';
  funktionEN: string = '';
}
